import Vue from 'vue/dist/vue.js'
import $ from 'jquery'
import axios from 'axios'

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.APP_URL;

axios.get('/sanctum/csrf-cookie').then(response => {
  // set session cookie
})

// GET PROJECT ID FROM URL
// sets project_id from the URL when on my project internal page

var project_id

function getIDfromURL() {
  const urlParams = new URLSearchParams(window.location.search)
  project_id = urlParams.get('id')
  return project_id
}

getIDfromURL()

// MY PROJECT USER CHECK
// check the user is admin, showroom_staff or it is their own project

if (document.getElementById('user-check')) {

  new Vue({
    el: '#user-check',
    name: 'User Check',
    data() {
      return {
        userProjectList: null,
        currentUser: null,
      }
    },
    mounted() {

      var p1 = axios.get('/api/user').
        then((response) => {
          this.currentUser = response.data.data
        }).
        catch(error => {
          console.log('Not logged in. Redirect to homepage.');
          window.location.href = '/';
        })

      var p2 = axios.get('/api/projects').
        then((response) => {
          this.userProjectList = response.data.data
        }).
        catch(error => console.log('DEBUG:', error))

      var sharedtest = axios.get('/api/shared-project/' + project_id).
        then((response) => response.data.data.pivot.project_id).
        catch(error => console.log('DEBUG:', error))

      Promise.all([p1, p2, sharedtest]).then((response) => {

          var pivot = response[2];

          if (this.currentUser.role === 'admin') {
            console.log('Admin - allow access')
            $('.internal-loader').hide()
          }
          else if (this.currentUser.role === 'showroom_staff') {
            console.log('Showroom Staff - allow access')
            $('.internal-loader').hide()
          }
          else if (this.currentUser.role === 'sharer' && project_id === pivot) {
            console.log('Share Link - allow access')
            $('.internal-loader').hide()
            $('#notes').hide()
            $('#dropContainer').hide()
            $('#documentupload').hide()
            $('.send-quote').hide()
            $('.share-team').hide()
            $('.message-history').hide()

            // also hide edit functionality - then block on post
          }
          else if (this.userProjectList.some(projectItem => parseInt(projectItem.id) === parseInt(project_id))) {
            console.log('Own project - allow access')
            $('.internal-loader').hide()
          }
          else {
            console.log('Permission Denied - Redirect')
            if (this.currentUser.role === 'sharer') {
              //window.location.replace('/');
            }
            else {
              window.location.replace('/my-projects')
            }

          }

        },
      )

    },
  })

}

// MY PROJECT TOP MENU
// this is the My Project link in the top website menu
// return whether user is logged in and project count

if (document.getElementById('project-menus')) {

  new Vue({
    el: '#project-menus',
    name: 'Project Menus',
    data() {
      return {
        currentUser: null,
        projectCount: null,
      }
    },
    async mounted() {
      try {
        const userRes = await axios.get('/api/user');
        this.currentUser = userRes.data.data
      } catch (e) {
        // do nothing
      }

      const projRes = await axios.get('/api/projects');
      this.projectCount = projRes.data.data.length
    },
  })

}

// CHECK USER PRODUCT INTERNAL
// Check if user logged in

if (document.querySelector('.js-add-to-project-plumbing')) {

  new Vue({
    el: '.js-add-to-project-plumbing',
    name: 'Add to Project Plumbing',
    data() {
      return {
        isLoggedIn: null,
      }
    },
    mounted() {
      axios.get('/api/user').
        then(response => (this.isLoggedIn = response.data.data)).
        catch(error => {
          // console.log(error)
          // do nothing
        })
    },
    methods: {
      addProductPopup() {
        $('.add-product-popup-wrapper').show();
        $('#add-project-form .manual-input').show();
        $('#add-project-form .sort-by').show();
        $('#add-project-form button').show();
        $('.add-to-project-success').hide();
      },
      addLoginPopup() {
        $('.my-project-popup-wrapper').show();
      },
    },
  })

}


// ADD PRODUCT TO PROJECT
// add product to selected project from landing or product pages

if (document.getElementById('add-product')) {

  new Vue({
    el: '#add-product',
    name: 'Add Product',
    data: {
      projects: '',
      projectId: '',
      product_uuid: '',
      product_name: '',
      product_sku: null,
      product_description: null,
      product_option: null,
      product_brand: null,
      product_image_url: null,
      userrole: null,
    },
    mounted() {
      axios.get('/api/projects').
        then(response => (this.projects = response.data.data)).
        catch(error => console.log('DEBUG:', error));

      axios.get('/api/user').then(response => {
        this.userrole = response.data.data.role;
        if (this.userrole === 'admin' || this.userrole ===
          'showroom_staff') {
          $('.manual-input').show()
        }

      }, (error) => {
        if (error && error.response && error.response.status === 404) {
          $('.add-to-project-error-not-found').show()
        }
      })

    },
    methods: {
      addToProject(submitEvent) {

        if (this.userrole === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {

          if (this.projectId !== null && this.projectId !== '') {

            if (document.querySelector('.slick-active')) {
              $('#productimageurl').val(document.querySelector('.slick-active').querySelector('.product-gallery-slide').src);
            }

            axios({
              method: 'post',
              url: '/api/project/' + this.projectId + '/product',
              data: {
                product_uuid: $('#productid').val(),
                product_name: $('#productname').val(),
                product_sku: $('#productsku').val(),
                product_brand: $('#productbrand').val(),
                product_description: $('#producturl').val(), // it bears the URL despite the name is product description :)
                product_option: window.oakleys.selectedProductOptions, // PHP does stringify so JS can skip it
                product_image_url: $('#productimageurl').val(),
              },
            }).then(() => {
              $('#add-project-form .manual-input').hide()
              $('#add-project-form .sort-by').hide()
              $('#add-project-form button').hide()
              $('.add-to-project-success').show()
              $('.add-to-project-error-not-found').hide()
              $('.add-to-project-error').hide()
            }, (error) => {
              if (error && error.response && error.response.status === 404) {
                $('.add-to-project-error-not-found').show()
              }
            })

          }
          else {
            $('.add-to-project-error').show()
          }

        }

      },
    },
  })

}

// PROJECT DOCUMENTS
// get list of documents and upload functionality

if (document.getElementById('document-list')) {

  new Vue({
    el: '#document-list',
    name: 'Document list',
    data: {
      documentlist: [],
      file: '',
      uploadPercentage: 0,
      role: 'test',
    },
    mounted() {
      axios.get('/api/project/' + project_id + '/files').then((response) => {
        this.documentlist = response.data.data
        if (window.user_role === 'sharer') {this.role = 'sharer'}
      }, (error) => {
        console.log('Error: ' + error)
      })
    },
    methods: {
      deleteFile(fileuuid) {

        if (window.user_role === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {

          if (confirm('Are you sure that you want to delete this file?')) {
            axios.delete('/api/project/' + project_id + '/file/' + fileuuid).
              then(response => {
                axios.get('/api/project/' + project_id + '/files').then(
                  response => (this.documentlist = response.data.data),
                ).catch(
                  error => console.log(error),
                )
                share.renderFiles()

              }).
              catch(error => {
                console.log(error.response)
              })

          }

        }
        return false
      },
      submitFile() {

        if (window.user_role === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {

          this.file = this.$refs.file.files[0]
          const config = {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: function(progressEvent) {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100))
              //console.log( this.uploadPercentage );
              $('.uploading').show()
              $('.loaded').css('width', this.uploadPercentage + '%')
              $('.uploading-doc').text(this.file.name)
            }.bind(this),
          }

          let formData = new FormData()
          formData.append('upload', this.file)
          axios.post('/api/project/' + project_id + '/file', formData, config).
            then((response) => {

              $('.uploading').hide()

              axios.get('/api/project/' + project_id + '/files').then(
                response => (this.documentlist = response.data.data),
              ).catch(
                error => console.log(error),
              )

              share.renderFiles()

            }, (error) => {
              console.log('Error: ' + error)
            })

        }

      },

    },
  })

}

// ADD COLOURS TO PROJECT

if (document.getElementById('colours')) {

  //var colours = {}

  new Vue({
    el: '#colours',
    name: 'Colours',
    data: {
      colours: '',
      newcolours: '',
      allcolours: [
        {'colour': 'colour-341E1E'},
        {'colour': 'colour-666666'},
        {'colour': 'colour-B3B3B3'},
        {'colour': 'colour-E6E6E6'},
        {'colour': 'colour-FFFFFF'},
        {'colour': 'colour-463700'},
        {'colour': 'colour-605019'},
        {'colour': 'colour-83774D'},
        {'colour': 'colour-B8B199'},
        {'colour': 'colour-EDECE6'},
        {'colour': 'colour-275526'},
        {'colour': 'colour-527751'},
        {'colour': 'colour-7D997D'},
        {'colour': 'colour-BECCBE'},
        {'colour': 'colour-E9EEE9'},
        {'colour': 'colour-122C53'},
        {'colour': 'colour-596B87'},
        {'colour': 'colour-8996A9'},
        {'colour': 'colour-B8C0CB'},
        {'colour': 'colour-E7EAEE'},
        {'colour': 'colour-30011D'},
        {'colour': 'colour-500230'},
        {'colour': 'colour-854E6E'},
        {'colour': 'colour-A88198'},
        {'colour': 'colour-DCCCD6'},
      ],
    },
    mounted() {
      axios.get('/api/project/' + project_id).then(
        response => (this.colours = response.data.data.colours),
      ).catch(
        error => console.log(error),
      )
    },
    methods: {
      isSelected: function(thecolour) {
        var i
        for (i = 0; i < this.colours.length; i++) {
          if (this.colours[i].colour === thecolour) {
            return true
          }
        }
      },
      addColour(colouroption) {

        if (window.user_role === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {
          var colourcount
          var addcolour
          var currentcolours = this.colours

          colourcount = currentcolours.length // # of existing items

          if (colourcount > 4) {
            $('.colour-alert').show()
          }
          else {
            $('.colour-alert').hide()
            let obj = currentcolours
            obj.push({'colour': colouroption})
            let i = 0, ln = obj.length
            for (i; i < ln; i++) {
              obj[i].colourNumber = i + 1
            }
            addcolour = obj
          }

          axios({
            method: 'put',
            url: '/api/project/' + project_id,
            data: {
              colours: addcolour,
            },
          }).then((response) => {
            share.renderColours()
          }, (error) => {
            console.log(error.response)
          })

        }

      },
      deleteColour(colouroption) {

        if (window.user_role === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {

          $('.colour-alert').hide()

          let obj = this.colours

          var i
          var deleteId
          for (i = 0; i < obj.length; i++) {
            if (obj[i].colour === colouroption) {
              deleteId = this.colours[i].colourNumber
            }
          }

          deleteId = deleteId - 1
          obj.splice(deleteId, 1)

          let x = 0, lnx = obj.length
          for (x; x < lnx; x++) {
            obj[x].colourNumber = x + 1
          }

          deletecolours = obj

          axios({
            method: 'put',
            url: '/api/project/' + project_id,
            data: {
              colours: deletecolours,
            },
          }).then((response) => {

            // success
            share.renderColours()

          }, (error) => {

            console.log(error.response)

          })

        }

      },
    },
  })

}

// ADD NOTE TO PROJECT

if (document.getElementById('notes')) {

  new Vue({
    el: '#notes',
    name: 'Notes',
    data: {
      notes: [],
      newnote: '',
    },
    mounted() {
      axios.get('/api/project/' + project_id).then(
        response => (this.notes = JSON.parse(response.data.data.notes)),
      ).catch(
        error => console.log('DEBUG:', error),
      )
    },
    methods: {
      addNote(submitEvent) {

        if (window.user_role === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {

          var currentnotes = this.notes

          var date = new Date()
          var day = date.getDate()
          var months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December']
          var month = months[date.getMonth()]
          var year = date.getFullYear()
          var hours = date.getHours()
          var minutes = date.getMinutes()
          var seconds = date.getSeconds()
          var hours = date.getHours()
          var minutes = date.getMinutes()
          var ampm = hours >= 12 ? 'pm' : 'am'
          hours = hours % 12
          hours = hours ? hours : 12
          minutes = minutes < 10 ? '0' + minutes : minutes
          var strTime = hours + ':' + minutes + ':' + seconds + ' ' + ampm
          var currentdate = (day + ' ' + month + ' ' + year + ' ' + strTime)

          if (currentnotes !== null && currentnotes !== '') {

            // get current json
            var createnote = this.newnote
            var currentnotes = this.notes
            let obj = currentnotes
            obj.push({'date': currentdate, 'note': createnote})

            let i = 0, ln = obj.length
            for (i; i < ln; i++) {
              obj[i].uniqueId = i + 1
            }

            createnote = JSON.stringify(obj)

          }
          else {
            var createnote = this.newnote
            var obj = [{'date': currentdate, 'note': createnote}]

            let i = 0, ln = obj.length
            for (i; i < ln; i++) {
              obj[i].uniqueId = i + 1
            }

            createnote = JSON.stringify(obj)
          }

          axios({
            method: 'put',
            url: '/api/project/' + project_id,
            data: {
              notes: createnote,
            },
          }).then((response) => {

            // success

            $('#newnotes').val('')
            //el.notes = response;

          }, (error) => {

            console.log(error.response)

          })

        }

      },
      deleteNote(noteId) {

        if (window.user_role === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {

          let obj = this.notes

          noteId = noteId - 1
          obj.splice(noteId, 1)

          let i = 0, ln = obj.length
          for (i; i < ln; i++) {
            obj[i].uniqueId = i + 1
          }

          const deletenote = JSON.stringify(obj)

          if (confirm('Are you sure that you want to delete this note?')) {

            axios({
              method: 'put',
              url: '/api/project/' + project_id,
              data: {
                notes: deletenote,
              },
            }).then((response) => {

              // success
              $('#newnotes').val('')

            }, (error) => {

              console.log(error.response)

            })

          }

        }

        return false

      },
    },
  })

}

const productOptionAdapter = {
  methods: {
    productOptionAdapter(textOrString) {
      if (Array.isArray(textOrString)) {
        let temp = [];
        textOrString.forEach(item => {
          temp.push(item.name);
        })
        return temp.join(', ');
      } else {
        return textOrString;
      }
    },
  }
};

if (document.getElementById('my-project-title')) {

  new Vue({
    el: '#my-project-title',
    name: 'My Project Title',
    data() {
      return {
        project: 0,
      }
    },

    mounted() {
      axios.get('/api/project/' + project_id).then(
        response => (this.project = response.data.data),
      ).catch(
        error => console.log(error),
      )
    },
  })
}

if (document.getElementById('my-project-product-list')) {
  new Vue({
    el: '#my-project-product-list',
    name: 'My Project Product List',
    data() {
      return {
        productList: 0,
        draggedElem: null,
        overElem: null,
        role: null,
      }
    },
    mixins: [productOptionAdapter],
    mounted() {
      axios.get('/api/project/' + project_id + '/products').then((response) => {
        this.productList = response.data.data;

        if (window.user_role === 'sharer') {
          this.role = 'sharer'
        }
      }, (error) => {
        console.log('Error: ' + error)
        window.location.href = '/';
      })
    },
    computed: {
      handleDropClasses() {
        return item => {
          if (!this.overElem || !this.overElem.id) {
            return "";
          }
          if (this.overElem.id === item.id && item.order < this.draggedElem.order) {
            return "drop-place drop-place--before";
          }
          if (this.overElem.id === item.id && item.order > this.draggedElem.order) {
            return "drop-place drop-place--after";
          }
        };
      }
    },
    methods: {
      pickupElem(event, elem, index) {
        // console.log('pickupElem');
        event.dataTransfer.dropEffect = "move";
        this.draggedElem = { ...elem };
      },
      showDropPlace(event, elem, index) {
        // console.log('showDropPlace');
        if (elem.id !== this.draggedElem.id) {
          this.overElem = { ...elem };
        } else {
          this.overElem = null;
        }
      },
      moveElem(event, elem, index) {
        // console.log('moveElem');
        this.productList = this.productList.filter(item => item.id !== this.draggedElem.id);
        this.productList.splice(index, 0, { ...this.draggedElem }); // insert the dragged element
        this.productList.forEach((item, index) => (item.order = index + 1)); // give them new order
        // the new order determines display order (reactive rendering)
      },
      dragEndClear() {
        // console.log('dragEndClear');
        this.draggedElem = null;
        this.overElem = null;

        this.productList.forEach(item => {
          let formData = new FormData();
          formData.append('order', item.order);
          // use \/project\/.+\/product\/.+ to find where else this API endpoint is used
          axios.put('/api/project/' + project_id + '/product/' + item.id, `order=${item.order}`, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          })
          .then(res => res.json())
          .then(json => {
            console.log(json);
          })
          .catch(e => {
            console.log(e)
          })
        })
      },
      deleteProduct(productId) {

        if (window.user_role === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {

          if (confirm('Are you sure that you want to delete this product?')) {
            axios.delete(
              '/api/project/' + project_id + '/product/' + productId).
              then(response => {
                $('.product-delete-alert').show()
                $('#product-' + productId).hide()
                share.renderProducts()
              }).
              catch(error => {
                console.log(error.response)
              })
          }
        }
        return false;
      },
      buildOptionsUrl(textOrString) {
        if (Array.isArray(textOrString)) {
          let temp = [];
          textOrString.forEach(item => {
            temp.push(item.typeSlug + ':' + item.slug+','+item.id);
          })
          return '?product-options=' + temp.join('|');
        }
        return "";
      }
    },
  })
}

if (document.getElementById('share')) {

  var share = new Vue({
    el: '#share',
    name: 'Share',
    data: {
      productlist: null,
      colours: '',
      documentlist: 0,
      messages: 0,
      user: 0,
      shareEmailList: '',
    },
    mixins: [productOptionAdapter],
    mounted() {
      axios.get('/api/project/' + project_id + '/products').then(
        response => (this.productlist = response.data.data),
      ).catch(
        error => console.log(error),
      ),
        axios.get('/api/project/' + project_id).then(
          response => (this.colours = response.data.data.colours),
        ).catch(
          error => console.log(error),
        ),
        axios.get('/api/project/' + project_id + '/files').then(
          response => (this.documentlist = response.data.data),
        ).catch(
          error => console.log(error),
        ),
        axios.get('/api/project/' + project_id + '/messages').then(
          response => (this.messages = response.data.data.slice().reverse()),
        ).catch(
          error => console.log(error),
        ),
        axios.get('/api/user').then(
          response => (this.user = response.data.data),
        ).catch(
          error => {
            // console.log(error)
            // do nothing
          }
        )

    },
    methods: {
      renderColours() {

        axios.get('/api/project/' + project_id).then(
          response => (this.colours = response.data.data.colours),
        ).catch(
          error => console.log(error),
        )

      },
      renderFiles() {
        axios.get('/api/project/' + project_id + '/files').then(
          response => (this.documentlist = response.data.data),
        ).catch(
          error => console.log(error),
        )
      },
      renderProducts() {
        axios.get('/api/project/' + project_id + '/products').then(
          response => (this.productlist = response.data.data),
        ).catch(
          error => console.log(error),
        )
      },
      shareEmails(submitEvent) {

        if (window.user_role === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {

          $('.share-button').css('opacity', '0.3')

          axios({
            method: 'post',
            url: '/api/project/' + project_id + '/share', // was put and no
                                                          // share to add to
                                                          // project only
            data: {
              share_emails: this.shareEmailList,
            },
          }).then((response) => {
            console.log(response)
            $('.email-error').removeClass('active')
            $('.email-success').addClass('active')
            $('#email-list').val('')
            $('.share-button').css('opacity', '1')
          }, (error) => {
            console.log(error)
            $('.email-success').removeClass('active')
            $('.email-error').addClass('active')
            $('.share-button').css('opacity', '1')
          })

        }

      },
      sendEnquiry() {

        if (window.user_role === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {

          // disable button and add loader

          $('#message').prop('disabled', true)
          $('.send-quote').find('.button').prop('disabled', true)
          $('.sending-quote').css('display', 'flex')

          axios({
            method: 'put',
            url: '/api/project/' + project_id,
            data: {
              status: 'enquiry',
              type: 'enquiry',
            },
          }).then((response) => {
            //
          }, (error) => {
            console.log(error.response)
          })

          axios({
            method: 'post',
            url: '/api/project/' + project_id + '/message-customer',
            data: {
              message: $('#message').val(),
            },
          }).then((response) => {
            //
          }, (error) => {
            console.log(error.response)
          })

          axios({
            method: 'put',
            //url: '/api/project/' + project_id + '/message-customer',
            url: '/api/project/' + project_id + '/send-quote',
            data: {
              message: $('#message').val(),
            },
          }).then((response) => {
            window.location.href = '/my-projects/thank-you'
          }, (error) => {
            console.log(error.response)
            // enable buttons, remove loader and show error
            $('#message').prop('disabled', false)
            $('.send-quote').find('.button').prop('disabled', false)
            $('.sending-quote').css('display', 'none')
          })

        }

      },
      getQuote() {

        if (window.user_role === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {

          // disable button and add loader

          $('#message').prop('disabled', true)
          $('.send-quote').find('.button').prop('disabled', true)
          $('.sending-quote').css('display', 'flex')

          axios({
            method: 'put',
            url: '/api/project/' + project_id,
            data: {
              status: 'lead',
              type: 'quote',
            },
          }).then((response) => {
            //
          }, (error) => {
            console.log(error.response)
          })

          axios({
            method: 'post',
            url: '/api/project/' + project_id + '/message-customer',
            data: {
              message: $('#message').val(),
            },
          }).then((response) => {
            //
          }, (error) => {
            console.log(error.response)
          })

          axios({
            method: 'put',
            //url: '/api/project/' + project_id + '/message-customer',
            url: '/api/project/' + project_id + '/send-quote',
            data: {
              message: $('#message').val(),
            },
          }).then((response) => {
            window.location.href = '/my-projects/thank-you'
          }, (error) => {
            console.log(error.response)
            // enable buttons, remove loader and show error
            $('#message').prop('disabled', false)
            $('.send-quote').find('.button').prop('disabled', false)
            $('.sending-quote').css('display', 'none')
          })

        }

      },
    },
  })

}

// REGISTER FORM

new Vue({
  el: '#register-form',
  name: 'Register form',
  data: {
    name: '',
    email: '',
    password: '',
    passwordConfirmation: '',
  },
  methods: {
    registerFormValues(submitEvent) {

      axios({
        method: 'post',
        url: '/register',
        data: {
          name: this.name,
          email: this.email,
          password: this.password,
          password_confirmation: this.passwordConfirmation,
        },
      }).then((response) => {

        // success
        location.reload()

      }, (error) => {

        if (error.response.data.errors.email) {
          $('.register-error').show()
          $('.register-error').
            html('An account with that email address already exists.')
        }

        if (error.response.data.errors.password) {
          $('.register-error').show()
          $('.register-error').html('The passwords do not match.')
        }

        console.log(error.response.data)

      })

    },
  },
})

// LOGIN FORM

new Vue({
  el: '#login-form',
  name: 'Login form',
  data: {
    email: '',
    password: '',
  },
  methods: {
    getFormValues(submitEvent) {
      axios({
        method: 'post',
        url: '/login-project',
        data: {
          email: this.email,
          password: this.password,
        },
      }).then((response) => {
        console.log(response)
        // $('.my-project-popup-wrapper').hide(); // hide login form
        location.reload()
      }, (error) => {
        console.log(error)
        $('.login-error').show()
      })

    },
  },
})

// CREATE PROJECT

if (document.getElementById('create-project')) {

  new Vue({
    el: '#create-project',
    name: 'Create project',
    data: {
      email: '',
      password: '',
      projectName: '',
      projectLocation: '',
      projectShowroom: 'North Island',
    },
    methods: {
      getFormValues(submitEvent) {
        axios({
          method: 'post',
          url: '/api/project',
          data: {
            name: this.projectName,
            location: this.projectLocation,
            colours: [],
            notes: [],
            showroom: this.projectShowroom,
          },
        }).then((response) => {
          console.log(response)
          location.reload()
        }, (error) => {
          console.log(error)
          $('.login-error').show()
        })
      },
    },
  })

}

// PROJECT LIST

if (document.getElementById('project-list')) {

  new Vue({
    el: '#project-list',
    name: 'Project List',
    data() {
      return {
        projects: 0,
        projectImages: 0
      }
    },

    async mounted() {

      const userRes = await axios.get('/api/user');
      if (userRes.status !== 200) {
        window.location.href = '/';
        return;
      }

      axios.get('/api/projects').then(
        response => {
          this.projects = response.data.data
          const array = response.data.data.map(e => e.id)

          let images = []
          let promises = []
          for (let i = 0; i < array.length; i++) {
            promises.push(axios.get('/api/project/' + array[i] + '/image'))
          }
          Promise.all(promises).then(
            responses => (this.projectImages = responses),
          )
        },
      ).catch(
        error => console.log(error),
      )
    },
    methods: {
      projectImageClick(projectid) {

        if (window.user_role === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {

          $('.project-image-upload-popup-wrapper').
            find('#projectimageid').
            val(projectid);

          $('.project-image-upload-popup-wrapper').show();

        }

      },
      orderBy(sortValue) {

        if (sortValue === 'default') {
          function compare(a, b) {
            if (a.created_at < b.created_at) {
              return -1
            }
            if (a.created_at > b.created_at) {
              return 1
            }
            return 0
          }

          //return this.projects.sort(compare);

          // rebuild projectImages order

          const array = this.projects.sort(compare).map(e => e.id)
          console.log(array)
          let images = []
          let promises = []
          for (i = 0; i < array.length; i++) {
            promises.push(axios.get('/api/project/' + array[i] + '/image'))
          }
          Promise.all(promises).then(
            responses => (this.projectImages = responses),
          )

          return this.projects.sort(compare)

        }

        if (sortValue === 'modified') {
          function compare(a, b) {
            if (a.updated_at > b.updated_at) {
              return -1
            }
            if (a.updated_at < b.updated_at) {
              return 1
            }
            return 0
          }

          // rebuild projectImages order

          const array = this.projects.sort(compare).map(e => e.id)
          console.log(array)
          let images = []
          let promises = []
          for (i = 0; i < array.length; i++) {
            promises.push(axios.get('/api/project/' + array[i] + '/image'))
          }
          Promise.all(promises).then(
            responses => (this.projectImages = responses),
          )

          return this.projects.sort(compare)

        }

        if (sortValue === 'alphabetical') {
          function compare(a, b) {
            if (a.name < b.name) {
              return -1
            }
            if (a.name > b.name) {
              return 1
            }
            return 0
          }

          //return this.projects.sort(compare);

          // rebuild projectImages order

          const array = this.projects.sort(compare).map(e => e.id)
          console.log(array)
          let images = []
          let promises = []
          for (i = 0; i < array.length; i++) {
            promises.push(axios.get('/api/project/' + array[i] + '/image'))
          }
          Promise.all(promises).then(
            responses => (this.projectImages = responses),
          )

          return this.projects.sort(compare)

        }

      },
      deleteProject(projectId) {

        if (window.user_role === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {

          if (confirm(
            'Are you sure that you want to delete this project? It cannot be recovered.')) {
            axios.delete('/api/project/' + projectId).then(response => {
              //location.reload();
              $('.project-delete-alert').show()
              $('#project-' + projectId).hide()
            }).catch(error => {
              console.log(error)
            })

          }

        }

        return false
      }
    },
  })

}

// PROJECT IMAGE UPLOAD

if (document.getElementById('projectimagupload')) {

  new Vue({
    el: '#projectimagupload',
    name: 'Project Image Upload',
    data: {
      file: '',
      projectimageid: '',
    },
    methods: {
      handleDocumentUpload(event) {
        this.file = this.$refs.file.files[0]
        console.log(this.file)
      },
      submitDocument() {

        if (window.user_role === 'sharer') {
          console.log('Access Denied')
          return false
        }
        else {

          //var projectimageid = '4';
          var projectimageid = document.getElementById('projectimageid').value

          let formData = new FormData()
          formData.append('upload', this.file)
          axios.post('/api/project/' + projectimageid + '/image', formData,
            {headers: {'Content-Type': 'multipart/form-data'}}).
            then((response) => {
              //console.log('Success!');
              location.reload()
            }, (error) => {
              console.log('Error: ' + error)
            })

        }

      },
    },
  })

}

// DATE FILTERS

Vue.filter('formatDate', function(value) {
  if (value) {
    var date = new Date(String(value))
    var day = date.getDate()
    var month = date.getMonth()
    var month = month + 1
    var year = date.getFullYear()
    var newDate = (day + '/' + month + '/' + year)
    return newDate
  }
})

Vue.filter('formatDateMessage', function(value) {
  if (value) {
    var date = new Date(String(value))
    var day = date.getDate()
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December',
    ]
    var month = monthNames[date.getMonth()]
    var year = date.getFullYear()
    var hours = date.getHours()
    var mins = date.getMinutes()
    var secs = date.getMinutes()
    if (mins < 10) {
      mins = '0' + mins
    }
    if (secs < 10) {
      secs = '0' + secs
    }
    var ampm = 'AM'
    if (hours > 12) {
      hours -= 12;
      ampm = "PM";
    }
    var newDate = (day + ' ' + month + ' ' + year + ' ' + hours + ':' + mins +
      ':' + secs + ' ' + ampm);
    return newDate;
  }
})


if(document.getElementById("searchapp")){

  var searchapp = new Vue({
    el: '#searchapp',
    name: 'Search app',
    data: {
      searchClient: instantMeiliSearch(
        'https://meilisearch1.syd.aws.16h.io:443', // http://127.0.0.1:7700
        'b002e5e8fb13b99549a5dbbf011e4ae4d54c897798c7a291ae4393ce5333fe68',
        {
          placeholderSearch: false,
          paginationTotalHits: 100,
        }
      ),
    },
    methods: {
      searchFunction(helper){
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        var query = params.get("q");
        helper.setQuery(query).search();
      },
      urlContains(url) {
        var string = 'plumbing-supplies';
        return url.includes(string)
      }
    },
  })

}

